import { useState } from "react";

/* PACKAGES */
import { motion } from "framer-motion";
import * as yup from "yup";
import { useFormik } from "formik";
import { Link } from "react-router-dom";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* USER DEFINED COMPONENTS */
import { FormInput } from "../../components/core/input";
import { FormButton } from "../../components/core/buttons";

/* ICONS */
import { IoEye, IoEyeOff } from "react-icons/io5";

/* UTILS */
import { containerAnimation, animation } from "../../utils/animation";

/* VALIDATION SCHEMA */
const loginValidation = yup.object().shape({
  email: yup.string().email().required("Email address is required"),
  password: yup.string().min(2, "Too short").required("Password is required"),
});

const LoginPage = () => {
  const [loginPassword, setLoginPassword] = useState(false);

  /* LOGIN FORM HANDLER */
  const loginHandler = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginValidation,
    onSubmit: (values) => {
      console.log("Login values: ", values);
    },
  });

  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="bg-white py-6 xl:py-14 lg:py-14"
    >
      {/* AUTHENTICATION */}
      <motion.div variants={animation} className="p-0">
        <div className="container">
          <div className="w-2/5 mx-auto">
            {/* LOGIN */}
            <motion.div variants={animation} className="col-span-1">
              <div className="bg-greyBg border border-greyBorder shadow rounded-lg p-5 xl:p-10 lg:p-10">
                <h2 className="text-2xl font-fraunces-bold tracking-tight text-black">
                  Returning Customer
                </h2>
                <p className="text-base font-source font-normal text-headerGrey">
                  If you are a registered user, please enter your email and
                  password.
                </p>
                <div className="mt-5">
                  <form className="mt-0">
                    <div className="form-group">
                      <label className="text-sm font-source font-medium text-black">
                        Email address
                      </label>
                      <div className="mt-1">
                        <FormInput
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Type your email address"
                          value={loginHandler.values.email}
                          onChange={loginHandler.handleChange}
                          errorHandler={
                            loginHandler.errors.email &&
                            loginHandler.touched.email
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group mt-5">
                      <label className="text-sm font-source font-medium text-black">
                        Password
                      </label>
                      <div className="mt-1 relative">
                        <FormInput
                          type={loginPassword ? "text" : "password"}
                          name="password"
                          id="password"
                          placeholder="Type your password"
                          value={loginHandler.values.password}
                          onChange={loginHandler.handleChange}
                          errorHandler={
                            loginHandler.errors.password &&
                            loginHandler.touched.password
                          }
                        />
                        <Button
                          className="p-2 rounded-full shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-10 bg-transparent !absolute top-2 right-2"
                          onClick={() => setLoginPassword(!loginPassword)}
                        >
                          {loginPassword ? (
                            <IoEyeOff className="w-5 h-5 text-headerGrey" />
                          ) : (
                            <IoEye className="w-5 h-5 text-headerGrey" />
                          )}
                        </Button>
                      </div>
                    </div>
                    <div className="mt-5">
                      <Link to="/dashboard" className="block">
                        <FormButton
                          type="button"
                          label="Login to your account"
                          className="w-full bg-primary"
                        />
                      </Link>
                      <p className="mt-3 text-sm font-source font-normal text-center">
                        Don't have an account?{" "}
                        <Link
                          to="/register"
                          className="text-sm font-source font-semibold text-primaryRed"
                        >
                          Create an account
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default LoginPage;
